import { render, staticRenderFns } from "./BoardsListPage.vue?vue&type=template&id=39dbd15e&scoped=true"
import script from "./BoardsListPage.vue?vue&type=script&lang=ts"
export * from "./BoardsListPage.vue?vue&type=script&lang=ts"
import style0 from "./BoardsListPage.vue?vue&type=style&index=0&id=39dbd15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbd15e",
  null
  
)

export default component.exports